import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Fade from '@mui/material/Fade';

import {useSessionContext} from '../contexts/SessionContext';

import Copyright from '../components/common/Copyright';
import logo from '../resources/logo-Southwire.png';


const AppModePage = (props) => {
    //console.debug("RTS Break AppModePage");

    const {user, setAppMode, setSessionCustomer, prevSessionCustomer, setPrevSessionCustomer} = useSessionContext();

    const history = useNavigate();

    function setCurrentMode(val){
        setAppMode(val);
        
        if(val==='PALLETS' || val==='MANUFACTURING' || val==='REELINSPECTIONS' || val==='INVENTORY'){
            setSessionCustomer({accessLevel:100, customer:{idGuid:'-99', idSap:'', name:'None'}});
            setPrevSessionCustomer({accessLevel:100, customer:{idGuid:'-99', idSap:'', name:'None'}});
        }
        else{
            if(prevSessionCustomer != null){
                if(prevSessionCustomer.customer.idGuid === '-99'){
                    setSessionCustomer(null);
                    setPrevSessionCustomer(null);
                }
            }
        }

        history("*", {state: {}});
    }


    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Box sx={{marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <Box>
                    <Typography component="h1" variant="h5">
                        Reel Tracking System
                    </Typography>
                    <Box sx={{display:'flex', alignItems:'center'}}>
                        <Typography sx={{fontSize:'.5em', fontWeight:'bold', textAlign:'right', width:'60%'}}>
                            Powered By
                        </Typography>
                        <Fade in>
                            <Box component="img" src={logo} alt={"Southwire"} sx={{ ml:1, width: "30%" }} />
                        </Fade>
                    </Box>
                </Box>
                <Typography component="h1" variant="h5">
                    Application Mode
                </Typography>
                <Stack spacing={2} sx={{mt:2}}>
                    {
                        user.modReelsFlag===1
                        ?
                        <Button variant='contained' onClick={() => {setCurrentMode('REELS');}}>
                            <Typography>Reel Tracking</Typography>
                        </Button>
                        :
                        ''
                    }
                    {
                        user.modManufacturingFlag===1
                        ?
                        <Button variant='contained' onClick={() => {setCurrentMode('MANUFACTURING');}}>
                            <Typography>Manufacturing</Typography>
                        </Button>
                        :
                        ''
                    }   
                    {
                        user.modReelInspectionsFlag===1
                        ?
                        <Button variant='contained' onClick={() => {setCurrentMode('REELINSPECTIONS');}}>
                            <Typography>Reel Inspections</Typography>
                        </Button>
                        :
                        ''
                    }                                        
                    {
                        user.modInventoryFlag===1
                        ?
                        <Button variant='contained' onClick={() => {setCurrentMode('INVENTORY');}}>
                            <Typography>Reel Inventory</Typography>
                        </Button>
                        :
                        ''
                    }
                    {
                        user.modPalletsFlag===1
                        ?
                        <Button variant='contained' onClick={() => {setCurrentMode('PALLETS');}}>
                            <Typography>Pallet Tracking</Typography>
                        </Button>
                        :
                        ''
                    }
                </Stack>
            </Box>
            <Copyright sx={{ mt: 8, mb: 4 }} />
        </Container>
      );
}

export default AppModePage;
